import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import BookDetail from '@/components/screens/book-detail/BookDetail';
import { API_URL } from '@/helpers/variables';
import { IBookDetailData } from '@/interfaces/bookDetail.interface';
import { IReviews } from '@/interfaces/reviews.interface';
import { IMenuData } from '@/interfaces/menu.interface';
import { MENU_API } from '@/helpers/variables';

interface IBookDetailPage extends IMenuData {
  book: IBookDetailData;
  reviews: IReviews;
}

const BookDetailPage: NextPage<IBookDetailPage> = ({ book, reviews, menuGenres, menuNew }) => {
  return <BookDetail book={book} reviews={reviews} menuGenres={menuGenres} menuNew={menuNew} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { id } = context.query;

  const [bookRes, reviewsRes, menuNewRes, menuGenresRes] = await Promise.all([fetch(`${API_URL}satellite/books/${id}`), fetch(`${API_URL}satellite/reviews/?book_id=${id}&page=1&page_size=5`), fetch(`${MENU_API.news}`), fetch(`${MENU_API.genres}`)]);
  const [book, reviews, menuNew, menuGenres] = await Promise.all([bookRes.json(), reviewsRes.json(), menuNewRes.json(), menuGenresRes.json()]);

  // Check Fetched Data Error
  if (!book.id) {
    return {
      notFound: true,
    };
  }

  return { props: { book, reviews, menuNew, menuGenres } };
};

export default BookDetailPage;
